import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";
import { onResponseUpdateTypeOfMeeting } from "./helpers";

export const updateTypeOfMeeting = async ({
  id,
  title,
}: UpdateTypeOfMeetingReqT) =>
  axios.put(urlMaker(Routes.UPDATE_TYPE_OF_MEETING, id), { title });

export const useUpdateTypeOfMeeting = () =>
  useMutation({
    mutationKey: [Keys.UPDATE_TYPE_OF_MEETING],
    mutationFn: updateTypeOfMeeting,
    onSettled: onResponseUpdateTypeOfMeeting,
    cacheTime: Infinity,
  });
